import { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import Button from 'components/CncUI/Button';
import TextFieldEmail from 'components/CncUI/TextField/TextFieldEmail';
import TextFieldSin from 'components/CncUI/TextField/TextFieldSin';
import TextFieldSsn from 'components/CncUI/TextField/TextFieldSsn';
import Dropdown from 'components/CncUI/Dropdown';

import isEmail from 'utilities/validateEmail';
import isSSN from 'utilities/validateSSN';
import isSIN from 'utilities/validateSIN';

const useStyles = makeStyles(() => ({
  button: {
    width: 100,
  },
}));

const SearchControls = props => {
  const classes = useStyles();
  const { onSearch, onClear, loading, onModify, state } = props;
  const idType = state.searchType;
  const typeList = [0, 1].includes(state.tab)
    ? ['SSN', 'Email']
    : ['SSN', 'SIN', 'Email'];

  useEffect(() => {
    // Only reset to SSN if next tab does not have the SIN option,
    // Which means reset to SSN for tab 0 or 1. Else try to preserve search values
    idType === 'SIN' && state.tab < 2 && onModify({ searchType: 'SSN' });
  }, [state.tab]);

  const clear = () => {
    onModify({ searchValue: '' });
    onClear();
  };

  const onKeyDown = e => {
    const { charCode, keyCode } = e || {};
    // Enter key 13
    if (charCode === 13 || keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      if (!loading) {
        onSearch(state.searchValue);
      }
    }
  };

  const TextInput =
    idType === 'SSN'
      ? TextFieldSsn
      : idType === 'SIN'
      ? TextFieldSin
      : TextFieldEmail;

  const textInputValidator =
    idType === 'SSN' ? isSSN : idType === 'SIN' ? isSIN : isEmail;

  const options = {};
  if (idType === 'SSN' || idType === 'SIN') {
    options.showAll = true;
  }

  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item>
        <Dropdown
          value={state.searchType}
          placeholder="Select an option"
          onChange={e => onModify({ searchType: e.target.value })}
          light
        >
          {typeList.map(value => (
            <Dropdown.Item key={value} value={value}>
              {value}
            </Dropdown.Item>
          ))}
        </Dropdown>
      </Grid>
      <Grid item lg={3} md={4} sm={5} xs={12}>
        <TextInput
          light
          fullWidth
          label="Search"
          value={state.searchValue}
          onChange={e => onModify({ searchValue: e.target.value })}
          onKeyDown={onKeyDown}
          startIcon={<SearchIcon />}
          onClear={() => onModify({ searchValue: '' })}
          id="SearchField"
          {...options}
        />
      </Grid>
      <Grid item>
        <Button
          id="SearchButton"
          loading={loading}
          disabled={!textInputValidator(state.searchValue)}
          onClick={() => onSearch(state.searchValue)}
          className={classes.button}
        >
          Search
        </Button>
      </Grid>
      <Grid item>
        <Button secondary id="ClearButton" onClick={clear}>
          Clear Results
        </Button>
      </Grid>
    </Grid>
  );
};

export default SearchControls;
